module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gontenschwil-2c8343ea6c7dad061f42138dc97a627d.svg";